module.exports = __webpack_public_path__ + "img/tem19.ff92d728.png";